let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b4OPs")).then(() => parcelRequire('kPU5q'));